module.exports = __webpack_public_path__ + "static/media/video_image2.7d1ddcf9.svg";